(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class XasBrandHeader extends HTMLElement {
    connectedCallback() {
      this.shell = this.closest('.section-header') || this;
      this.brand = this.querySelector('.xas-brand');
      this.morphDistancePx = 90;
      this.lastScrollTop = 0;
      this.isHidden = false;
      this.downAccum = 0;
      this.upAccum = 0;
      this.fadeOnScroll = this.getAttribute('data-fade-on-scroll') === 'true';
      this.fadeMode = this.getAttribute('data-fade-mode') || 'slide';
      this.predictiveSearch = this.querySelector('predictive-search');
      this._heightTimer = null;

      if (this.fadeMode === 'product') {
        this.shell.classList.add('is-product-header');
      }
      if (this.fadeMode === 'home') {
        this.shell.classList.add('is-home-header');
      }

      // Homepage: slide away / back. Product: floating text slides quickly. Elsewhere: full slide.
      if (this.fadeMode === 'home') {
        this.fadeDelayPx = 40;
        this.fadeDistancePx = 0;
        this.hideAfterDownPx = 180;
        this.showAfterUpPx = 10;
      } else if (this.fadeMode === 'product') {
        this.fadeDelayPx = 8;
        this.fadeDistancePx = 0;
        // Mobile: wait longer before sliding away so controls stay tappable
        this.hideAfterDownPx = window.matchMedia('(max-width: 749px)').matches ? 120 : 40;
        this.showAfterUpPx = 10;
      } else {
        this.fadeDelayPx = 12;
        this.fadeDistancePx = 0;
        this.hideAfterDownPx = 72;
        this.showAfterUpPx = 12;
      }

      this.cacheAnnouncement();
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = () => {
        this.cacheAnnouncement();
        this.onScroll();
      };

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });

      this.syncHeaderHeight();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this._heightTimer) clearTimeout(this._heightTimer);
    }

    cacheAnnouncement() {
      this.announcement =
        document.querySelector('.utility-bar') ||
        document.querySelector('.announcement-bar') ||
        document.querySelector('.announcement-bar-section');
    }

    getMorphStartY() {
      if (this.announcement) {
        return this.announcement.offsetTop + this.announcement.offsetHeight;
      }
      return this.shell.offsetTop + 8;
    }

    syncHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.shell.offsetHeight}px`);
      if (this._heightTimer) clearTimeout(this._heightTimer);
      this._heightTimer = setTimeout(() => {
        document.documentElement.style.setProperty('--header-height', `${this.shell.offsetHeight}px`);
      }, 380);
    }

    setHeaderVisible(visible) {
      const wasHidden = this.isHidden;
      this.isHidden = !visible;

      if (this.fadeMode === 'home') {
        // Homepage: slide up to hide, slide down to return
        this.shell.style.opacity = '1';

        if (visible) {
          if (wasHidden) {
            // Already off-screen via is-xas-slid-away — animate back down
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this.shell.style.transition = '';
                this.shell.classList.remove('is-xas-slid-away', 'is-xas-faded-out');
              });
            });
          } else {
            this.shell.classList.remove('is-xas-slid-away', 'is-xas-faded-out');
          }
        } else {
          this.shell.style.transition = '';
          this.shell.classList.add('is-xas-slid-away', 'is-xas-faded-out');
        }
        return;
      }

      // Slide modes (product + other pages): keep opaque, move off-screen
      this.shell.style.opacity = '1';
      this.shell.classList.toggle('is-xas-slid-away', !visible);
      this.shell.classList.toggle('is-xas-faded-out', !visible);
    }

    onScroll() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const startY = this.getMorphStartY();
      const progress = Math.min(Math.max((scrollTop - startY) / this.morphDistancePx, 0), 1);
      const showLogo = progress >= 0.28;
      const delta = scrollTop - this.lastScrollTop;
      const nearTop = scrollTop <= startY + this.fadeDelayPx;

      // Brand morph always follows scroll position
      this.shell.classList.toggle('scrolled-past-header', scrollTop > startY);
      this.shell.classList.toggle('is-brand-logo', showLogo);
      this.shell.classList.remove('is-compact');
      if (this.brand) this.brand.classList.toggle('is-morphed', showLogo);

      if (!this.fadeOnScroll) {
        this.setHeaderVisible(true);
        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        return;
      }

      // All pages: slide away on scroll down, slide back on scroll up
      if (nearTop) {
        this.downAccum = 0;
        this.upAccum = 0;
        this.setHeaderVisible(true);
      } else if (delta > 0) {
        this.downAccum += delta;
        this.upAccum = 0;
        if (this.downAccum >= this.hideAfterDownPx) {
          this.setHeaderVisible(false);
          this.downAccum = 0;
        }
      } else if (delta < 0) {
        this.upAccum += -delta;
        this.downAccum = 0;
        if (this.upAccum >= this.showAfterUpPx) {
          this.setHeaderVisible(true);
          this.upAccum = 0;
        }
      }

      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    hide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.setHeaderVisible(true);
    }

    reset() {
      this.setHeaderVisible(true);
      this.shell.classList.remove(
        'scrolled-past-header',
        'is-brand-logo',
        'is-compact',
        'is-xas-slid-away'
      );
      if (this.brand) this.brand.classList.remove('is-morphed');
      this.syncHeaderHeight();
    }

    closeMenuDisclosure() {
      this.querySelectorAll('header-menu').forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      const searchModal = this.querySelector('details-modal');
      if (searchModal && typeof searchModal.close === 'function') searchModal.close(false);
    }
  }

  if (!customElements.get('xas-brand-header')) {
    customElements.define('xas-brand-header', XasBrandHeader);
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', class extends HTMLElement {});
  }

  } catch(e) { console.error(e); }
})();
})();
